export default __webpack_public_path__ + "static/media/erlandsontrade.6cdd3ab9.jpg";